module.exports = __webpack_public_path__ + "public/images/dome-desktop.470a07171c0249b01b021c7f529d9ae5.svg";